<div id="class-details" [ngClass]="{'iframe': isIframeRoute}">
    <div class="classes-area ptb-lg-100">
        <div class="container px-0">
            <app-alert></app-alert>
            <div class="ph-item" *ngIf="!sessionDetails">
                <div class="ph-col-8">
                    <div class="ph-picture"></div>
                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-4 empty big"></div>
                        <div class="ph-col-2 big"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-6 empty"></div>
                        <div class="ph-col-12"></div>
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-4 empty big"></div>
                        <div class="ph-col-2 big"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-6 empty"></div>
                        <div class="ph-col-12"></div>
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-4 empty big"></div>
                        <div class="ph-col-2 big"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-6 empty"></div>
                        <div class="ph-col-12"></div>
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-4 empty big"></div>
                        <div class="ph-col-2 big"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-6 empty"></div>
                        <div class="ph-col-12"></div>
                    </div>
                </div>
                <div class="ph-col-4">
                    <div class="ph-picture"></div>
                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-4 empty big"></div>
                        <div class="ph-col-2 big"></div>
                    </div>
                </div>
            </div>
            <div class="row m-0" *ngIf="sessionDetails">
                <div class="col-lg-7 col-md-12 offset-lg-1 mt-4 px-0 section-wrapper">
                    <div class="banner-wrapper">
                        <button type="button" class="btn btn-secondary back-button" title="Back" (click)="goBack()">
                        </button>
                        <button *ngIf="currentMember" type="button" class="btn btn-secondary favorite-button" [ngClass]="{'favorited': isFavorite()}" [title]="isFavorite() ? 'Remove from Favorites' : 'Add to Favorites'" (click)="toggleFavorite()">
                            <i [class]="isFavorite() ? 'bi bi-heart-fill' : 'bi bi-heart'"></i>
                        </button>
                        <ng-container *ngIf="allowInviteFriends">
                            <button *ngIf="currentMember" type="button" class="btn btn-secondary invite-friend-button" title="Share" [disabled]="submitted" (click)="inviteFriends()">
                            </button>
                        </ng-container>
                        <div class="banner-image" [ngStyle]="getBannerImageStyle()" [title]="sessionDetails?.ClassName"></div>
                    </div>
                    <div class="studio-name-photo-wrapper px-3">
                        <div class="row">
                            <div class="col-7">
                                <!-- <img *ngIf="sessionDetails?.StudioNamePhoto" [src]="sessionDetails?.StudioNamePhoto" [alt]="sessionDetails?.Studio?.Name" [title]="sessionDetails?.Studio?.Name" /> -->
                                <!-- <img *ngIf="!sessionDetails?.StudioNamePhoto" [src]="logo" [alt]="sessionDetails?.Class?.Name" [title]="sessionDetails?.Class?.Name" /> -->
                                <!-- <div class="class-name-wrapper" *ngIf="!sessionDetails?.StudioNamePhoto">
                                    <h1 class="class-name">{{sessionDetails?.Class?.Name}}</h1>
                                </div> -->
                                <div class="class-name-wrapper">
                                    <h1 *ngIf="sessionDetails?.Theme" class="class-name">{{sessionDetails?.Theme}}</h1>
                                    <h1 *ngIf="sessionDetails?.Theme" class="class-name with-theme text-muted">{{sessionDetails?.Class?.Name}}</h1>
                                    <h1 *ngIf="!sessionDetails?.Theme" class="class-name">{{sessionDetails?.Class?.Name}}</h1>
                                </div>
                            </div>
                            <div class="col-5 session-timing">
                                <p>{{dayOfWeek}}, {{month}} {{dayOfMonth}}</p>
                                <p>{{startTime}} - {{endTime}}{{timeZoneAbbr ? ' ' + timeZoneAbbr : ''}}</p>
                            </div>
                        </div>
                    </div>
                    
                    <h3 class="mb-3 mt-3 section-heading px-3">Class Details</h3>
                    
                    <div class="instructor-details-wrapper">
                        <div *ngIf="sessionDetails.InstructorDefaultAvatar" class="instructor-photo-wrapper">
                            <img [src]="sessionDetails.InstructorDefaultAvatar" [alt]="sessionDetails.InstructorName" class="rounded-circle instructor-photo" />
                        </div>
                        <div class="instructor-details">
                            <p class="instructor-label">Instructor</p>
                            <p class="instructor-name">{{sessionDetails.InstructorName}}</p>
                        </div>
                    </div>
                    <div class="class-description px-3">
                        <p>
                            <span>{{sessionDetails.Class.Name}}</span> - 
                            <span>{{sessionDetails.Class.Description}}</span>
                        </p>
                    </div>

                    <h3 class="mb-3 mt-3 section-heading px-3" *ngIf="sessionDetails.Class.HowToPrepare != '' && sessionDetails.Class.HowToPrepare != null">How To Prepare?</h3>
                    <div class="class-description px-3"  *ngIf="sessionDetails.Class.HowToPrepare != '' && sessionDetails.Class.HowToPrepare != null">
                        <p>
                            <span>{{sessionDetails.Class.HowToPrepare}}</span>
                        </p>
                    </div>

                    <h3 class="mb-3 mt-3 section-heading px-3">Amenities</h3>
                    <div class="amenities-wrapper px-3">
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-4 p-0" *ngFor="let amenity of amenities; trackBy: trackByAmenityId">
                                <div class="amenity">
                                    <img [src]="'/assets/images/svg/' + amenity.Icon" [alt]="amenity.Name" [title]="amenity.Name" />
                                    <p>{{amenity.Name}}</p>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
                <div class="col-lg-3 col-md-12 mt-4 map-section" *ngIf="sessionDetails.Class.AddressId != null && sessionDetails.Class.AddressId != 0">
                    <h3 class="m-3 section-heading">Location
                        <a [href]="directionUrl" target="_blank" class="direction-link">Get Direction</a>
                    </h3>
                    <app-map [latitude]="sessionDetails.Class.Address.Latitude" [longitude]="sessionDetails.Class.Address.Longitude" [details]="sessionDetails.Class.Address.AddressStr"></app-map>
                </div>
            </div>
        </div>
        <div class="floating-footer" *ngIf="sessionDetails">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-sm-12 offset-lg-1 p-lg-2 " style="position: relative;">
                        <p class="spots-left-label">{{spotsLeftText()}}</p>
                        <button *ngIf="showLockedReserve()" class="btn btn-primary reserve-spot-button" (click)="openPremiumUpgrade()">
                            🔒 RESERVE
                        </button>
                        <button *ngIf="showJoinWaitlist()" [ngClass]="{'btn':true, 'btn-primary': spotsLeft!==0, 'btn-secondary-outline': spotsLeft===0, 'reserve-spot-button':true}" (click)="JoinWaitlistClicked()">
                            JOIN WAITLIST
                        </button>
                        <button *ngIf="showCancelWaitlist()" [ngClass]="{'btn':true, 'btn-primary': spotsLeft!==0, 'btn-secondary-outline': spotsLeft===0, 'reserve-spot-button':true}" (click)="CancelWaitlistClicked()">
                            CANCEL WAITLIST
                        </button>
                        <button *ngIf="showReserve()" [ngClass]="{'btn':true, 'btn-primary': spotsLeft!==0, 'btn-secondary-outline': spotsLeft===0, 'reserve-spot-button':true}" (click)="openSpotMapClicked()">
                            RESERVE
                        </button>
                        <button *ngIf="isInFuture() && isSessionBooked" class="btn btn-primary cancel-spot-button" (click)="cancelReservation(classMember.Id)">
                            CANCEL CLASS
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<df-login #login title="Log into your account" (loggedIn)="loggedIn($event)"></df-login>
<df-presale-book #presaleBook title="Presale Booking" (booked)="booked($event)"></df-presale-book>